import React, { Component } from 'react';
import { Translate } from '$common';



export default class CheckBox extends Component {
  static type = 'checkbox';
  static optionable = true;
  static elementName = Translate.get('multiple_choice');
  static icon = 'check-square';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/checkbox.js